import {ChangeDetectorRef, Component, OnInit, ViewChild} from '@angular/core';
import {
  ContainerTypes,
  FilterCardData,
  GeneralFilter,
  Service,
  ServiceOrder,
  TableColumn,
  ToastConfig,
  SortDirection,
  ConfirmationModalComponent,
  ConfirmationModalConfig
} from '@app/shared';
import {ProjectSortService} from '../../services/project-sort.service';
import {ProjectUtilsService} from '../../services/project-utils.service';
import {ProjectService, ScreenService} from '@app/core';
import {ProjectContainer} from '../../../../shared/models/project-container';
import {NzDrawerService} from 'ng-zorro-antd/drawer';
import {combineLatest, finalize, take} from 'rxjs';
import {GlobalValuesService} from '../../../../core/services/global-values.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {ContainerDetailDrawerComponent} from '../../drawers/container-detail-drawer/container-detail-drawer.component';
import {ContainerCreateDrawerComponent} from '../../drawers/container-create-drawer/container-create-drawer.component';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

interface FilterValues {
  containerTypeFilterValue: any;
  serviceFilterValue: any;
  serviceOrderFilterValue: any;
}

type FilterMap = {
  [key: string]: keyof FilterValues;
};

@Component({
  selector: 'app-container-section',
  standalone: false,

  templateUrl: './container-section.component.html',
  styleUrl: './container-section.component.less'
})
export class ContainerSectionComponent implements OnInit {

  loading: boolean = false;

  /** Variables de filtrado **/
  totalUsedContainers: number = 0;
  totalFreeContainers: number = 0;

  cardsFilters: FilterCardData[] = [
    {
      label: 'Contenedores',
      active: false,
    },
    {
      label: 'Contenedores usados',
      active: false,
    },
    {
      label: 'Contenedores disponibles',
      active: false,
    },
  ];
  generalFilters: GeneralFilter[] = [
    {
      name: 'Tipo',
      active: false,
      icon: 'arrow_drop_down',
      value: undefined,
    },
    // {
    //   name: 'Servicio',
    //   active: false,
    //   icon: 'arrow_drop_down',
    //   value: undefined,
    // },
    // {
    //   name: 'Orden',
    //   active: false,
    //   icon: 'arrow_drop_down',
    //   value: undefined,
    // },
  ];
  searchValue: string = '';
  containerTypeFilterValue: ContainerTypes | undefined;
  serviceFilterValue: Service | undefined;
  serviceOrderFilterValue: ServiceOrder | undefined;
  containerTypeList: ContainerTypes[] = [];
  containerTypeAvailable: ContainerTypes[] = [];
  serviceList: Service[] = [];
  serviceOrderList: ServiceOrder[] = [];
  /** Variables de tabla **/
  columns: TableColumn[] = [
    {
      name: '',
      width: '65',
      checkbox: true,
      align: 'center'
    },
    {
      name: 'Referencia Contenedor',
      pathData: { name: 'containerRef', type: 'text' },
      width: '224',
      align: 'left',
    },
    {
      name: 'Tipo',
      pathData: { name: 'containerType.description', type: 'text' },
      align: 'left'
    },
    // {
    //   name: 'Servicio',
    //   width: '224',
    //   align: 'left'
    // },
    // {
    //   name: 'Orden de Servicio',
    //   align: 'left'
    // },
  ];
  filteredContainers: ProjectContainer[] = [];
  /** Variables de seleccion **/
  selectedContainerIds = new Set<number>();
  isIndeterminate: boolean = false;
  isAllSelected: boolean = false;
  detailDrawerRef: any;
  createDrawerRef: any;
  /** Variables de feedback **/
  toastConfig: ToastConfig = {
    icon: 'check_circle',
    iconColor: '#6CDA75',
    content: 'Proyecto creado correctamente.',
    showUndo: false
  };
  notRef: any;
  @ViewChild('notificationTmpl') notificationTmpl: any;
  @ViewChild('confirmationModal') confirmationModal!: ConfirmationModalComponent;
  private pendingDeleteId?: number;
  // Mapa de filtros con tipado seguro
  private readonly filterValueMap: FilterMap = {
    'Tipo': 'containerTypeFilterValue',
    'Servicio': 'serviceFilterValue',
    'Orden': 'serviceOrderFilterValue'
  };

  constructor(
    public ps: ProjectUtilsService,
    public gs: GlobalValuesService,
    public screenService: ScreenService,
    public authService: AuthService,
    private projectService: ProjectService,
    private drawerService: NzDrawerService,
    private notificationService: NzNotificationService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private projectSortService: ProjectSortService,
  ) {
    gs.containerTypes$.pipe(takeUntilDestroyed())
      .subscribe(value => this.containerTypeList = value);
  }

  ngOnInit() {
    this.loading = true;
    // this.setFilterData();
    this.filter();
    this.configureSortFunctions();

    this.loading = false;
  }

  /** Logica de seleccion de Equipos **/
  //region Seleccion
  // Alternamiento individual
  toggleSelectContainer(id: number): void {
    const newSet = new Set(this.selectedContainerIds);

    if (newSet.has(id)) {
      newSet.delete(id);
    } else {
      newSet.add(id);
    }

    this.selectedContainerIds = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  // Alternamiento total
  toggleSelectAllContainer(): void {
    const shouldSelectAll = !this.isAllSelected;
    const newSet = new Set<number>();

    if (shouldSelectAll) {
      // Solo se marcan los libres
      this.filteredContainers.forEach(item => {
        newSet.add(item.id);
      });
    }

    this.selectedContainerIds = newSet;
    this.updateSelectionState(); // Actualizar estados después de cambiar
  }

  updateSelectionState(): void {
    const activeItems = this.filteredContainers;
    const activeCount = activeItems.length;
    const selectedCount = activeItems.filter(item =>
      this.selectedContainerIds.has(item.id)
    ).length;

    this.isAllSelected = activeCount > 0 && selectedCount === activeCount;
    this.isIndeterminate = selectedCount > 0 && selectedCount < activeCount;
  }

  //endregion

  /** Metodos de drawers **/
  //region Drawers
  openContainerCreateDrawer(isCreateContainer: boolean) {

    const selectedIds = Array.from(this.selectedContainerIds);

    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.createDrawerRef = this.drawerService.create({
        nzClosable: false,
        nzMask: true,
        nzWidth: 793,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: ContainerCreateDrawerComponent,
        nzData: {
          containers: this.ps.selectedProject!.projectContainers?.filter(c => selectedIds.includes(c.id)) || [],
          isCreateContainer,
          containerTypes: this.containerTypeList,
        }
      });

      this.createDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
        this.createDrawerRef.getContentComponent().updateContainers.pipe(take(1))
          .subscribe(() => {
            this.ngOnInit();
          });
      })
    });
  }

  openContainerDetailDrawer(container: ProjectContainer, readonly: boolean) {
    combineLatest({
      isMobile: this.screenService.isMobile$,
      isMedium: this.screenService.isMedium$,
    }).pipe(take(1)).subscribe(({isMobile, isMedium}) => {
      this.detailDrawerRef = this.drawerService.create({
        nzClosable: false,
        nzMask: false,
        nzWidth: 635,
        nzHeight: '98%',
        nzPlacement: isMobile ? 'bottom' : 'right',
        nzContent: ContainerDetailDrawerComponent,
        nzData: {
          container,
          readonly,
        }
      });

      this.detailDrawerRef.afterOpen.pipe(take(1)).subscribe(() => {
        this.detailDrawerRef.getContentComponent().updateContainer.pipe(take(1))
          .subscribe((value: ProjectContainer) => {
            if (this.ps.selectedProject!.projectContainers) {
              this.ps.selectedProject!.projectContainers = this.ps.selectedProject!.projectContainers
                .map(p => p.id === value.id ? value : p);
            }
            this.filter();
            this.cdr.detectChanges();
          });
      })
    });
  }

  //endregion

  /** Logica de filtrado **/
  //region Filtrado
  cardFilter(label: string) {
    this.cardsFilters.forEach(c => c.label === label ? c.active = !c.active : c.active = false);
    this.filter();
  }

  onFilterSelect(filterLabel: string, value: any): void {
    // Obtener la propiedad correspondiente al filtro con tipado seguro
    const filterProperty = this.filterValueMap[filterLabel];
    if (!filterProperty) return;

    // Encontrar el filtro actual
    const currentFilter = this.generalFilters.find(f => f.name === filterLabel);
    if (!currentFilter) return;

    // Obtener valor actual usando tipado seguro
    const currentValue = (this as FilterValues)[filterProperty];
    const isSameValue = currentValue === value;

    // Actualizar todos los filtros
    this.generalFilters.forEach(filter => {
      if (filter.name === filterLabel) {
        filter.active = !isSameValue;
        filter.value = isSameValue ? undefined : value;
      } else {
        filter.active = false;
        filter.value = undefined;
      }
    });

    // Actualizar el valor del filtro con tipado seguro
    (this as FilterValues)[filterProperty] = isSameValue ? undefined : value;

    // Aplicar filtros
    this.filter();
  }

  cleanSearch() {
    this.searchValue = '';
    this.filter();
  }

  setFilterData() {
    if (!this.ps.selectedProject?.projectContainers) {
      this.totalUsedContainers = 0;
      this.totalFreeContainers = 0;
      return;
    }

    this.totalUsedContainers = this.ps.selectedProject.projectContainers.filter(c => !!c.serviceOrder).length;
    this.totalFreeContainers = this.ps.selectedProject.projectContainers.filter(c => !c.serviceOrder).length;

    this.ps.selectedProject.projectContainers.forEach(c => {
      if (c.service) {
        this.serviceList.push(c.service);
      }
      if (c.serviceOrder) {
        this.serviceOrderList.push(c.serviceOrder);
      }
    })

  }

  openDeleteConfirmation(id: number) {
    this.pendingDeleteId = id;
    const config: ConfirmationModalConfig = {
      title: 'Eliminar elemento',
      message: '¿Estás seguro que deseas eliminar este elemento?',
      confirmText: 'Eliminar',
      cancelText: 'Cancelar',
      confirmButtonType: 'primary',
      confirmButtonDanger: true
    };
    this.confirmationModal.config = config;
    this.confirmationModal.open();
  }

  onDeleteConfirmed(data: {textValue?: string, dateValue?: Date}) {
    // this.loading = true;
    // Actualizar el estado del modal para mostrar loading
    this.confirmationModal.config.processing = true;
    if (this.pendingDeleteId) {
      this.deleteElement(this.pendingDeleteId);
    }
  }

  deleteElement(id: number) {
    this.projectService.deleteProjectContainer([id])
      .pipe(finalize(() => {
        this.showNotification();
        // this.loading = false;
        this.confirmationModal.config.processing = false;
        this.confirmationModal.forceClose();
      }))
      .subscribe({
        next: () => {
          if (this.ps.selectedProject!.projectContainers) {
            this.ps.selectedProject!.projectContainers = this.ps.selectedProject!.projectContainers.filter(c => c.id !== id);
          }
          this.filter();
          this.toastConfig.content = 'El Contenedor ha sido eliminado.';
          this.toastConfig.icon = 'check_circle';
          this.toastConfig.iconColor = '#6CDA75';
        },
        error: (e: any) => {
          console.error(e);
          this.toastConfig.content = 'Ha ocurrido un error eliminando el Contenedor.';
          this.toastConfig.msg = e.error.message;
          this.toastConfig.icon = 'dangerous';
          this.toastConfig.iconColor = '#CB2A2F';
        },
      })
  }

  showNotification(): void {
    this.notRef = this.notificationService
      .create("blank", '', this.notificationTmpl, { nzPlacement: "bottomRight" });
  }

  filter() {
    if (!this.ps.selectedProject || !this.ps.selectedProject.projectContainers) {
      this.filteredContainers = [];
      this.containerTypeAvailable = [];
      return;
    }
    let tempFilter = this.ps.selectedProject.projectContainers;

    this.containerTypeAvailable = tempFilter.reduce((acc: ContainerTypes[], container) => {
      if (container.containerType && !acc.some(ct => ct.id === container.containerType!.id)) {
        acc.push(container.containerType);
      }
      return acc;
    }, []);

    // Contenedores
    if(this.cardsFilters[0]?.active && this.ps.selectedProject?.projectContainers) tempFilter = this.ps.selectedProject.projectContainers;

    // Contenedores usados
    if(this.cardsFilters[1]?.active && this.ps.selectedProject?.projectContainers) tempFilter = this.ps.selectedProject.projectContainers.filter(c => !!c.serviceOrder);

    // Contenedores disponibles
    if(this.cardsFilters[2]?.active && this.ps.selectedProject?.projectContainers) tempFilter = this.ps.selectedProject.projectContainers.filter(c => !c.serviceOrder);

    // Tipo
    this.generalFilters[0]?.active ? tempFilter = tempFilter.filter(c => c.containerType?.id === this.containerTypeFilterValue?.id) : null;

    // Servicio
    this.generalFilters[1]?.active ? tempFilter = tempFilter.filter(c => c.service?.id === this.serviceFilterValue?.id) : null;

    // Orden
    this.generalFilters[2]?.active ? tempFilter = tempFilter.filter(c => c.serviceOrder?.id === this.serviceOrderFilterValue?.id) : null;

    if (this.searchValue) {
      tempFilter = tempFilter.filter(c => c.containerRef?.toLowerCase().includes(this.searchValue.toLowerCase()));
    }

    this.filteredContainers = [...tempFilter];
  }

  //endregion


  openServiceOrderInNewTab(projectId: number, serviceId: number, soRef: number) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(
        ['/projects/detail', projectId, 'service', serviceId],
        {
          queryParams: {
            openServiceOrderDrawer: 'true',
            soRef: soRef.toString()
          }
        }
      )
    );

    window.open(url, '_blank');
  }

  // Métodos de ordenamiento
  private configureSortFunctions(): void {
    this.projectSortService.configureSortFunctions(this.columns, (column) => this.handleSort(column));
  }

  private handleSort(column: TableColumn): void {
    if (!column.pathData) return;

    const { sortedData } = this.projectSortService.handleSort(column, this.filteredContainers, this.columns);
    this.filteredContainers = sortedData;
  }

  getColumnSortDirection(column: TableColumn): SortDirection {
    return column.sortDirection || null;
  }
}
